export const LEVEL_CONNECTION_TYPES = {
  FOUR_G: 1,
  WIFI: 2,
};

export const DEFAULT_LEVEL_CONNECTION_TYPE = LEVEL_CONNECTION_TYPES.FOUR_G;

export const LEVEL_CONNECTION_TYPE_OPTIONS = [
  { value: String(LEVEL_CONNECTION_TYPES.FOUR_G), label: "4G" },
  { value: String(LEVEL_CONNECTION_TYPES.WIFI), label: "Wifi" },
];

export const GSM_APN_CODES = {
  AIRTEL_4G: 1,
  VODAFONE_M2M: 8,
  AIRTEL_M2M: 9,
  JIO_M2M: 10,
};

export const DEFAULT_GSM_APN_CODE = GSM_APN_CODES.AIRTEL_4G;

export const GSM_APN_OPTIONS = [
  { value: String(GSM_APN_CODES.AIRTEL_4G), label: "Airtel 4G" },
  { value: String(GSM_APN_CODES.VODAFONE_M2M), label: "Vodafone M2M" },
  { value: String(GSM_APN_CODES.AIRTEL_M2M), label: "Airtel M2M" },
  { value: String(GSM_APN_CODES.JIO_M2M), label: "Jio M2M" },
];

export const GSM_APN_VALUE_SET = new Set(
  GSM_APN_OPTIONS.map((option) => option.value),
);

export const getLevelConnectionTypeCode = (connectionType) => {
  const numericValue = Number(connectionType);
  return numericValue === LEVEL_CONNECTION_TYPES.WIFI
    ? LEVEL_CONNECTION_TYPES.WIFI
    : LEVEL_CONNECTION_TYPES.FOUR_G;
};

export const getLevelConnectionTypeLabel = (connectionType) => {
  const code = getLevelConnectionTypeCode(connectionType);
  const option = LEVEL_CONNECTION_TYPE_OPTIONS.find(
    (item) => Number(item.value) === code,
  );

  return option?.label || "-";
};

export const isGsmApnCode = (gsmApnCode) =>
  GSM_APN_VALUE_SET.has(String(gsmApnCode));

export const getGsmApnCode = (gsmApnCode) => {
  const numericValue = Number(gsmApnCode);
  return isGsmApnCode(numericValue) ? numericValue : DEFAULT_GSM_APN_CODE;
};

export const getGsmApnLabel = (gsmApnCode) => {
  if (gsmApnCode === null || gsmApnCode === undefined || gsmApnCode === "") {
    return "-";
  }

  const option = GSM_APN_OPTIONS.find(
    (item) => item.value === String(gsmApnCode),
  );

  return option?.label || String(gsmApnCode);
};
